import { useState } from 'react';
import { useAuth } from './useAuth';
import { hacerSolicitud } from '../helpers/apiClient';
import { urlApi } from '../helpers/functionHelpers';

const useGuardarCitaInterna = () => {
  const { renovarToken, cerrarSesion } = useAuth(); 
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);


  const guardarCitaInterna = async (fecha, horaInicio, horaFin, numeroPersonas, motivo, unidad_id, almacenId) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await hacerSolicitud(
        `${urlApi}/api/citaInterna`,
        {
          method: 'POST',
          body: JSON.stringify({
            fecha,
            dataIni: horaInicio,
            dataFin: horaFin,
            numeroPersonas,
            motivo,
            unidad_id,
            almacenId,
          }),
        },
        renovarToken,
        cerrarSesion
      );

      setSuccess(true);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { guardarCitaInterna, error, success, loading };
};

export default useGuardarCitaInterna;
